// Device-token storage for the kitchen kiosk SPA. The token is the full
// bearer string returned by /api/kiosk/enroll/complete — already including
// the "device:" prefix — so apiFetch can blindly forward it.

const DEVICE_TOKEN_KEY = 'budget.deviceToken';

export function getDeviceToken(): string | null {
  try {
    const stored = localStorage.getItem(DEVICE_TOKEN_KEY);
    if (stored) return stored;
  } catch {
    /* ignore — fall through to the dev env fallback */
  }
  // The kitchen Pi serves the kiosk via `vite dev`, where the enrollment screen
  // is gated off (see KioskShell), so a real device token can't be entered
  // through the UI. Let the Pi provision one via VITE_KIOSK_DEVICE_TOKEN in its
  // own .env.local — that makes the kiosk authenticate as a real, remotely-
  // lockable kiosk_devices row instead of the read-only KIOSK_DEV_BYPASS device.
  // DEV-only (stripped from production builds) and not set on dev laptops, so
  // local development keeps falling back to the server-side bypass.
  if (import.meta.env.DEV) {
    const envToken = import.meta.env.VITE_KIOSK_DEVICE_TOKEN as string | undefined;
    if (envToken) return envToken;
  }
  return null;
}

export function setDeviceToken(token: string): void {
  try {
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearDeviceToken(): void {
  try {
    localStorage.removeItem(DEVICE_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function isOnKioskRoute(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.pathname.startsWith('/kiosk');
}
